/**
 * EL ANUNCIO POR EL QUE LLEGÓ EL CLIENTE, para pintarlo en el chat.
 *
 * El adaptador de WhatsApp lo guarda en `contact.anuncioJson` con el primer mensaje que llega
 * desde un anuncio de Facebook o Instagram («Enviar mensaje»). Sin esto el equipo no distingue
 * en la bandeja quién vino por publicidad y quién escribió solo (pedido de Esteban, 16-oct).
 *
 * PURO: cualquier forma inesperada da null y el chat se ve como siempre.
 */
export interface AnuncioDelCliente {
  sourceId: string;
  sourceUrl?: string;
  titulo?: string;
  cuerpo?: string;
}

export function anuncioDelContacto(contact: { anuncioJson?: unknown } | null | undefined): AnuncioDelCliente | null {
  const a = contact?.anuncioJson;
  if (!a || typeof a !== 'object' || Array.isArray(a)) return null;
  const r = a as Record<string, unknown>;
  const texto = (v: unknown) => (typeof v === 'string' && v.trim() ? v.trim() : undefined);
  const sourceId = texto(r.sourceId);
  if (!sourceId) return null;
  return { sourceId, sourceUrl: texto(r.sourceUrl), titulo: texto(r.titulo), cuerpo: texto(r.cuerpo) };
}
